import EXIF from "exif-js";
import exif2css from 'exif2css';
import { isChrome } from '../../../infrastructure/helpers';

const isChromeBrowser = isChrome();

export default function pinchZoom(elm) {
  const hammertime = new Hammer(elm, {});
  hammertime.get('pinch').set({
      enable: true
  });
  const isDefaultMatrix = () => {
    const matrix = window.getComputedStyle(el, null).getPropertyValue('-webkit-transform').toString();
    if (matrix === 'none') { return true; }
    return matrix.search(/(0, 0)\)/) !== -1; 
  }
  const getImageRotateString = (image) => {
    let rotate = '';
    EXIF.getData(image, () => {
      const orientation = EXIF.getTag(image, 'Orientation');
      if (orientation === 8 || orientation === 6) {
        const { transformStrings } = exif2css(orientation);
        rotate = transformStrings.rotate;
      }
    });
    return rotate;
  }
  
  let posX = 0,
      posY = 0,
      scale = 1,
      last_scale = 1,
      last_posX = 0,
      last_posY = 0,
      max_pos_x = 0,
      max_pos_y = 0,
      transform = "",
      el = elm;
  hammertime.on('tap pan pinch panend pinchend', (ev) => {
    if (ev.type === 'tap') {
      try {
        if (isDefaultMatrix()) {
          return setTimeout(() => { this.setState({ fullscreen: false }); }, 10);
        } else {
          transform = "translate3d(0, 0, 0) " + "scale3d(1, 1, 1) ";
          scale = 1;
          last_scale = 1;
        }
      } catch (err) { this.setState({ fullscreen: false }); }
    }

    //pan    
    if (scale != 1) {
      posX = last_posX + ev.deltaX;
      posY = last_posY + ev.deltaY;
      max_pos_x = Math.ceil((scale - 1) * el.clientWidth / 2);
      max_pos_y = Math.ceil((scale - 1) * el.clientHeight / 2);
      if (posX > max_pos_x) { posX = max_pos_x; }
      if (posX < -max_pos_x) { posX = -max_pos_x; }
      if (posY > max_pos_y) { posY = max_pos_y; }
      if (posY < -max_pos_y) { posY = -max_pos_y; }
    }

    //pinch
    if (ev.type == "pinch") {
      scale = Math.max(.999, Math.min(last_scale * (ev.scale), 4));
    }
    if(ev.type == "pinchend"){ last_scale = scale; }

    //panend
    if(ev.type == "panend"){
      last_posX = posX < max_pos_x ? posX : max_pos_x;
      last_posY = posY < max_pos_y ? posY : max_pos_y;
    }

    if (scale != 1) {
      transform = "translate3d(" + posX + "px," + posY + "px, 0) " + "scale3d(" + scale + ", " + scale + ", 1)";
    }
    if (transform) {
      if (isChromeBrowser && elm) {
        transform += getImageRotateString(elm);
      }
      el.style.webkitTransform = transform;
    }
  });
}